import { useQuery } from '@tanstack/react-query';
import { userApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Server-side user search, keyed by an already-debounced term. */
export function useUserSearchOptions(debouncedQuery: string) {
  return useQuery({
    queryKey: queryKeys.users.search(debouncedQuery),
    queryFn: ({ signal }) =>
      userApiClient.searchUsers(debouncedQuery, toCancelToken(signal)),
    placeholderData: (prev) => prev,
    staleTime: 60_000,
    meta: { errorContext: 'user search' },
  });
}
